import { createFileRoute } from '@tanstack/react-router'
import { FileSignature } from 'lucide-react'
import { z } from 'zod'
import { ContractsScreen } from '@/screens/improve/SCR-027-contracts'

export const Route = createFileRoute('/_app/w/$ws/contracts')({
  staticData: { screen: {"id":"SCR-027","title":"Contracts","group":"Improve","perm":["contract.manage","approval.review"],"order":5,"description":"Mandates and limits for agents, with versions and signatures.", icon: FileSignature } },
  validateSearch: z.object({ state: z.enum(['draft', 'pending_signatures', 'active', 'suspended', 'expired', 'terminated']).optional() }),
  component: ContractsScreen,
})
